if (!customElements.get('product-modal')) {
  const MODAL_DEBUG = false; // altere para true para ver logs de depuração

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._navClicked = false;
        this._debug = MODAL_DEBUG;
        this._boundDocumentCapture = null;
      }

      _log(...args) {
        if (this._debug) console.log('[ProductModal]', ...args);
      }

      connectedCallback() {
        super.connectedCallback();

        // Listener no DOCUMENT (fase captura) roda ANTES do listener do global.js no modal
        this._boundDocumentCapture = (event) => {
          if (!this.contains(event.target)) return;
          if (!event.target.closest('.product-media-modal__nav')) return;
          this._navClicked = true;
          this._log('_navClicked = true (document captura, antes do tema)');
          setTimeout(() => {
            this._navClicked = false;
            this._log('_navClicked = false (reset após 300ms)');
          }, 300);
        };
        document.addEventListener('click', this._boundDocumentCapture, true);

        this.querySelectorAll('.product-media-modal__nav').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            if (btn.classList.contains('is-disabled')) return;
            this._log('CLICK no botão de navegação', event.target.closest('.product-media-modal__nav')?.classList.contains('product-media-modal__nav--next') ? 'next' : 'prev');
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const direction = btn.classList.contains('product-media-modal__nav--next') ? 'next' : 'prev';
            this.scrollMedia(direction);
          });
        });

        const content = this.querySelector('[role="document"]');
        if (content) {
          content.addEventListener('scroll', () => this._updateDotsAndArrows());
        }

        this.querySelectorAll('.product-media-modal__dot').forEach((dot) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            const index = parseInt(dot.getAttribute('data-index'), 10);
            this._scrollToIndex(index);
          });
        });
      }

      disconnectedCallback() {
        if (this._boundDocumentCapture) {
          document.removeEventListener('click', this._boundDocumentCapture, true);
          this._boundDocumentCapture = null;
        }
        super.disconnectedCallback?.();
      }

      show(...args) {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        this._log('show() — modal aberto', args[0]?.getAttribute?.('data-media-id'));
        super.show(...args);
        this.showActiveMedia();
        setTimeout(() => this._updateDotsAndArrows(), 200);
      }

      // Intercepta o hide() do ModalDialog pai
      hide() {
        if (this._navClicked) {
          this._log('hide() BLOQUEADO — _navClicked é true (navegação)');
          return;
        }
        this._log('hide() CHAMADO — fechando modal');
        this._log('Stack trace:', new Error().stack);
        super.hide();
      }

      _updateDotsAndArrows() {
        const container = this.querySelector('[role="document"]');
        const dots = this.querySelectorAll('.product-media-modal__dot');
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');
        if (!container || !dots.length) return;

        const width = container.clientWidth;
        const total = container.children.length;
        const index = width > 0 ? Math.round(container.scrollLeft / width) : 0;
        const current = Math.min(Math.max(0, index), total - 1);

        dots.forEach((dot, i) => {
          const isActive = i === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive);
        });

        if (prevBtn) prevBtn.classList.toggle('is-disabled', current <= 0);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', current >= total - 1);
      }

      _scrollToIndex(index) {
        const container = this.querySelector('[role="document"]');
        if (!container) return;
        const width = container.clientWidth;
        const total = container.children.length;
        const i = Math.min(Math.max(0, index), total - 1);
        container.scrollTo({ left: i * width, behavior: 'smooth' });
      }

      scrollMedia(direction) {
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        const scrollAmount = container.clientWidth;
        container.scrollBy({
          left: direction === 'next' ? scrollAmount : -scrollAmount,
          behavior: 'smooth'
        });
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        const opener = this.openedBy;
        const mediaId = opener.getAttribute('data-media-id') || opener.closest('[data-media-id]')?.getAttribute('data-media-id');
        if (!mediaId) return;

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));
        activeMedia.classList.add('active');

        setTimeout(() => {
          activeMedia.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        }, 50);

        const activeMediaTemplate = activeMedia.querySelector('template');
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaTemplate) {
          activeMedia.loadContent();
        }
      }
    }
  );
}